import Jueguemos1 from '../assets/images/thumbnails/Jueguemos1.jpg'
import Jueguemos2 from '../assets/images/thumbnails/Jueguemos2.jpg'
import Jueguemos3 from '../assets/images/thumbnails/Jueguemos3.jpg'
import Jueguemos4 from '../assets/images/thumbnails/Jueguemos4.jpg'
import Jueguemos5 from '../assets/images/thumbnails/Jueguemos5.jpg'
import Jueguemos6 from '../assets/images/thumbnails/Jueguemos6.jpg'
import Jueguemos7 from '../assets/images/thumbnails/Jueguemos7.jpg'
import Jueguemos8 from '../assets/images/thumbnails/Jueguemos8.jpg'
import Jueguemos9 from '../assets/images/thumbnails/Jueguemos9.jpg'
import Jueguemos10 from '../assets/images/thumbnails/Jueguemos10.jpg'
import JALogo from '../assets/images/logo/LogoJA.png'
import JAP1 from '../assets/images/preview/JAP1.png'
import JAP2 from '../assets/images/preview/JAP2.png'
import JAP3 from '../assets/images/preview/JAP3.png'
import JAP4 from '../assets/images/preview/JAP4.png'
import JAP5 from '../assets/images/preview/JAP5.png'
import JAP6 from '../assets/images/preview/JAP6.png'
import JAP7 from '../assets/images/preview/JAP7.png'
import JAP8 from '../assets/images/preview/JAP8.png'
import JAP9 from '../assets/images/preview/JAP9.png'
import JAP10 from '../assets/images/preview/JAP10.png'

const Jueguemos = [
  {
    id: 1,
    section: 'Jueguemos',
    title: 'Minecraft Supervivencia Parte 1 - Cuanta lana negra!',
    thumbnailUrl: Jueguemos1,
    webUrl: 'https://www.youtube.com/embed/xYwsmUjRcq8', // Add the episode URL
    backgroundImage: JAP1,
    seriesLogo: JALogo,
    description: 'Iniciamos con esta madre!',
  },
  {
    id: 2,
    section: 'Jueguemos',
    title: 'Minecraft Supervivencia Parte 2 - Matando Cerditos Inocentes :D',
    thumbnailUrl: Jueguemos2,
    webUrl: 'https://www.youtube.com/embed/KFeBUIpEnM8', // Add the episode URL
    backgroundImage: JAP2,
    seriesLogo: JALogo,
    description: 'Seguimos con esta madre!',
  },
  {
    id: 3,
    section: 'Jueguemos',
    title: 'Minecraft Supervivecia Parte 3 - Publicidad Barata',
    thumbnailUrl: Jueguemos3,
    webUrl: 'https://www.youtube.com/embed/zoPQ_9GYh2g', // Add the episode URL
    backgroundImage: JAP3,
    seriesLogo: JALogo,
    description: 'Entren al server de Endo : endo.servegame.com Y jueguen conmigo, mi nombre de usuario es Rogumer.',
  },
  {
    id: 4,
    section: 'Jueguemos',
    title: 'Minecraft Supervivencia Parte 4 - Nos Alejamos de Casa',
    thumbnailUrl: Jueguemos4,
    webUrl: 'https://www.youtube.com/embed/RjX8sUv2A3g', // Add the episode URL
    backgroundImage: JAP4,
    seriesLogo: JALogo,
    description: 'Esta madre se empieza a poner interesante ahora que porfin nos alejamos de casa!',
  },
  {
    id: 5,
    section: 'Jueguemos',
    title: 'Minecraft Supervivencia Parte 5 - I Am Error...',
    thumbnailUrl: Jueguemos5,
    webUrl: 'https://www.youtube.com/embed/2X3lK1SXEzA', // Add the episode URL
    backgroundImage: JAP5,
    seriesLogo: JALogo,
    description: 'We continue with this shit!',
  },
  {
    id: 6,
    section: 'Jueguemos',
    title: 'Minecraft CO-OP Parte 1 - Desmadre al Triple!',
    thumbnailUrl: Jueguemos6,
    webUrl: 'https://www.youtube.com/embed/PqVsgP0EQSk', // Add the episode URL
    backgroundImage: JAP6,
    seriesLogo: JALogo,
    description: 'Este video NO es el ganador de la votación de 2000 Subs, el verdadero está tomando un tiempo, y de mientras subo esto, disfrutenlo, que ahora tenemos de compañía a 2 de mis amigos de los que he hablado varias veces, por fin van a conocer a estos 2 desmadrosos XD, y ahora, el desmadre se multiplica por tres!',
  },
  {
    id: 7,
    section: 'Jueguemos',
    title: 'Minecraft CO-OP Parte 2 - Templo del Desierto',
    thumbnailUrl: Jueguemos7,
    webUrl: 'https://www.youtube.com/embed/ubCAyGBMlb4', // Add the episode URL
    backgroundImage: JAP7,
    seriesLogo: JALogo,
    description: 'Seguimos caminando en busca de comida, topándonos con una casa instantánea!',
  },
  {
    id: 8,
    section: 'Jueguemos',
    title: 'Minecraft CO-OP Parte 3 - Calabozo del End!',
    thumbnailUrl: Jueguemos8,
    webUrl: 'https://www.youtube.com/embed/NqfanADQJfI', // Add the episode URL
    backgroundImage: JAP8,
    seriesLogo: JALogo,
    description: 'Ahora con unas cuantas mejoras tanto visuales como auditivas, continuamos explorando los alrededores del previamente encontrado Templo del Desierto, solo para encontrarnos con el que sería mi mejor descubrimiento en mi historia jugando Minecraft. OJO : El video NO está laggeado, solo lo están las partes que grabó La Chingada, pues al parecer, la PC de La Chingada tiene una memoria RAM de la chingada. Pun Intended ^___^',
  },
  {
    id: 9,
    section: 'Jueguemos',
    title: 'Slender Intento 1 - Lag Everywhere',
    thumbnailUrl: Jueguemos9,
    webUrl: 'https://www.youtube.com/embed/KRrKQdWPTd0', // Add the episode URL
    backgroundImage: JAP9,
    seriesLogo: JALogo,
    description: 'Iniciamos con una montaña de lag -_-',
  },
  {
    id: 10,
    section: 'Jueguemos',
    title: 'Slender Intento 2 - ¿Y Bongo Bongo? [Feat. "La Chingada"]',
    thumbnailUrl: Jueguemos10,
    webUrl: 'https://www.youtube.com/embed/-rraPYYoP9I', // Add the episode URL
    backgroundImage: JAP10,
    seriesLogo: JALogo,
    description: 'Volvemos a intentarlo, ahora con muuucho menos lag, y aparte, estamos acompañados por el señor profesor Dr. Drew Pea Cock! Digo la Chingada.',
  },
  ];

  export default Jueguemos;
